import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";

interface StorefrontStore {
	isCartModalOpen: boolean;
	openCartModal: () => void;
	closeCartModal: () => void;
}

export const useStorefrontStore = create<StorefrontStore>((set) => ({
	isCartModalOpen: false,
	openCartModal: () => set({ isCartModalOpen: true }),
	closeCartModal: () => set({ isCartModalOpen: false }),
}));

export const useCartModal = () =>
	useStorefrontStore(
		useShallow((store) => ({
			isCartModalOpen: store.isCartModalOpen,
			openCartModal: store.openCartModal,
			closeCartModal: store.closeCartModal,
		})),
	);
